export type MeasureUnit = 'kilogram' | 'millimeter';

export interface IMeasureParts {
    value: string;
    unit: string;
}

const FALLBACK_LOCALE = 'en-US';

// Matches the backend's card formatting: payload to half a kilogram, reach in whole millimetres, no grouping.
const MAXIMUM_FRACTION_DIGITS: Record<MeasureUnit, number> = {
    kilogram: 1,
    millimeter: 0,
};

function formatter(locale: string, unit: MeasureUnit): Intl.NumberFormat {
    const options: Intl.NumberFormatOptions = {
        style: 'unit',
        unit,
        unitDisplay: 'short',
        useGrouping: false,
        maximumFractionDigits: MAXIMUM_FRACTION_DIGITS[unit],
    };

    try {
        return new Intl.NumberFormat(locale || FALLBACK_LOCALE, options);
    } catch {
        return new Intl.NumberFormat(FALLBACK_LOCALE, options);
    }
}

/** A measurement formatted for the page's culture, e.g. `12.5 kg` or `12,5 kg`. */
export function formatMeasure(locale: string, unit: MeasureUnit, value: number): string {
    return formatter(locale, unit).format(value);
}

/** The number and unit of a formatted measurement, for layouts that style them apart. */
export function splitMeasure(locale: string, unit: MeasureUnit, value: number): IMeasureParts {
    const parts = formatter(locale, unit).formatToParts(value);

    return {
        value: parts
            .filter((part) => part.type !== 'unit' && part.type !== 'literal')
            .map((part) => part.value)
            .join(''),
        unit: parts
            .filter((part) => part.type === 'unit')
            .map((part) => part.value)
            .join(''),
    };
}
